"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatusClass = void 0;
const getStatusClass = (status) => {
    switch (status) {
        case 'Complete':
            return 'bg-green-500 text-white';
        case 'Notified':
            return 'bg-yellow-500 text-white';
        case 'Create':
            return 'bg-blue-500 text-white';
        case 'Failure':
            return 'bg-red-500 text-white';
        default:
            return 'bg-gray-500 text-white';
    }
};
exports.getStatusClass = getStatusClass;
